import { render, staticRenderFns } from "./CardForm.vue?vue&type=template&id=1282a5d7&lang=pug"
import script from "./CardForm.vue?vue&type=script&lang=js"
export * from "./CardForm.vue?vue&type=script&lang=js"
import style0 from "./CardForm.vue?vue&type=style&index=0&id=1282a5d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports